module.exports = __webpack_public_path__ + "img/Qualityserve-imgc.80c86dc2.png";